export enum BackgroundColor {
    main = "main",
    alt = "alt",
}
